// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import { createAsyncAction } from 'typesafe-actions';

import { Chapter } from '../../../types/Model';
import { Progress } from '../../../types/Model';

export interface IltCourseChaptersRequestPayload {
  id: number;
  preventLoading?: boolean;
}
export interface IltCourseChaptersSuccessPayload {
  id: number;
  chapters: Chapter[];
  progress: Progress[];
}

export interface IltCourseChaptersFailPayload {
  error: Error;
}

const getIltCourseContentsDataActions = createAsyncAction(
  'elearning/GET_ILT_COURSE_CHAPTERS_DATA',
  'elearning/GET_ILT_COURSE_CHAPTERS_DATA_SUCCESS',
  'elearning/GET_ILT_COURSE_CHAPTERS_DATA_FAIL'
)<
  IltCourseChaptersRequestPayload,
  IltCourseChaptersSuccessPayload,
  IltCourseChaptersFailPayload
>();

export { getIltCourseContentsDataActions as default }
